var _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmazonElasticBlockStore1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b660f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cae3e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 58h2v10H58v-2h6.586l-8.293-8.293 1.414-1.414L66 64.586zm-42.293-.293L15.414 66H22v2H12V58h2v6.586l8.293-8.293zM68 12v10h-2v-6.586l-8.293 8.293-1.414-1.414L64.586 14H58v-2zm-52.586 2l8.293 8.293-1.414 1.414L14 15.414V22h-2V12h10v2zm35.264 39.661c-1.157 1.187-5.043 2.385-11.115 2.385C32.168 56.046 28.031 54.23 28 53V29.857C30.603 31.395 35.32 32 39.563 32c4.193 0 8.855-.603 11.437-2.133v23.158c.002.074.008.298-.322.636zM39.563 24c6.1 0 9.982 1.181 11.123 2.352.322.33.316.55.314.623V27c0 1.226-4.073 3-11.437 3-7.141 0-11.531-1.735-11.56-2.987.058-1.267 4.09-3.013 11.56-3.013zm13.436 3c.008-.518-.141-1.284-.881-2.044C50.313 23.105 45.62 22 39.563 22 33.365 22 26.094 23.303 26 27v26.025c.095 3.706 7.365 5.021 13.563 5.021 4.657 0 10.399-.785 12.547-2.989.759-.779.903-1.562.89-2.057V27z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonElasticBlockStore1);
export default __webpack_public_path__ + "static/media/amazon-elastic-block-store-1.341b6f88d5fa529d1d2eca86ac56424b.svg";
export { ForwardRef as ReactComponent };